import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import { t } from 'i18next'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import MapComponent from '../../../modules/map/MapComponent'
import InputTextarea from '../../views/widgets/InputTextarea'
import { LOCATION_STATUS } from './GeneralInfoFormLocationContainer'

const GeneralInfoLocationForm = ({
  language = 'th',
  isShowMap = true,
  status,
  center,
  values,
  onBlur,
  onChange,
  onMarkerChange,
  onDefaultLocationClick,
}) => (
  <div className="columns">
    <div className="column">
      <Field label={t('place.latitude.label')}>
        <InputText
          name={`latitude`}
          type="number"
          placeholder={t('place.latitude.placeholder')}
          onChange={onChange}
          onBlur={onBlur}
          value={values.latitude}
        />
      </Field>
      <Field label={t('place.longitude.label')}>
        <InputText
          name={`longitude`}
          type="number"
          placeholder={t('place.longitude.placeholder')}
          onChange={onChange}
          onBlur={onBlur}
          value={values.longitude}
        />
      </Field>
      <Field label={`${t('place.streetAddress.placeholder')}[${language}]`}>
        <InputTextarea
          name={`streetAddress.${language}`}
          placeholder={t('place.streetAddress.placeholder')}
          onChange={onChange}
          onBlur={onBlur}
          value={values.streetAddress[language]}
        />
      </Field>
      <div className="has-text-right">
        <button
          className={classNames('button is-primary', {
            'is-loading': status === LOCATION_STATUS.PENDING,
          })}
          onClick={onDefaultLocationClick}
        >
          <span className="icon">
            <i className="fas fa-compass" />
          </span>
          <span>{t('place.currentPosition.label')}</span>
        </button>
      </div>
    </div>
    <div className="column">
      {isShowMap && _.isNumber(values.latitude) && (
        <MapComponent
          center={center}
          isMarkerShown
          onMarkerChange={onMarkerChange}
          onTextSearchChange={text => {
            if (_.isEmpty(values.streetAddress[language])) {
              onChange({
                target: { name: `streetAddress.${language}`, value: text },
              })
            }
          }}
          defaultCenter={{ lat: values.latitude, lng: values.longitude }}
          markers={[
            { position: { lat: values.latitude, lng: values.longitude } },
          ]}
        />
      )}
    </div>
  </div>
)

export default GeneralInfoLocationForm



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormLocation.js